














































import Modal from "../core/Modals/Modal.vue";
import PasswordInput from "../core/Forms/PasswordInput.vue";
import { UserApi } from "../api/UserApi";

export default {
    name: "ChangePasswordModal",
    components: { PasswordInput, Modal },
    props: {
        showModal: Boolean,
    },
    data() {
        return {
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
            UserApi: new UserApi(),
            currentUser: null,
        };
    },
    created() {
        let self = this;
        self.UserApi.getCurrentUser().then(function (user) {
            self.currentUser = user;
        });
    },
    methods: {
        // Actions
        save() {
            let self = this;

            self.currentUser.password = self.newPassword;
            self.UserApi.changePassword(self.currentUser, self.oldPassword)
                .then(function () {
                    swal(
                        "Succès",
                        "Mot de passe modifié avec succès",
                        "success"
                    );
                    self.closeModal();
                })
                .catch(function (err) {
                    swal("Erreur", "Mot de passe incorrect", "error");
                    self.closeModal();
                });
        },
        // UI
        closeModal() {
            this.oldPassword = "";
            this.newPassword = "";
            this.confirmPassword = "";
            this.$emit("close-modal");
        },
    },
    computed: {
        isIncompleteForm(): boolean {
            return (
                this.oldPassword.length < 1 ||
                this.newPassword.length < 1 ||
                this.confirmPassword != this.newPassword
            );
        },
    },
};
